<template>
  <!-- Header -->
  <div class="bg-white z-50 sticky w-full -top-1 border-b print:hidden">
    <div class="w-full mx-auto md:max-w-7xl justify-center p-4">
      <div class="flex flex-wrap justify-between items-center">
        <a :href="'/' + switchBlogLocale()" @click.prevent="goHome" class="flex items-center">
          <NuxtImg
            loading="lazy"
            src="/img/logo.svg"
            class="w-44 md:w-52 lg:w-60 max-w-full"
            alt="Better2Know"
            width="300"
            height="50"
          />
        </a>
        <div class="hidden md:flex md:w-4/6 lg:w-3/6">
          <slot name="tabs" />
        </div>
      </div>
    </div>
  </div>

  <!-- Content -->
  <main class="min-h-screen mb-20">
    <CommonSupport pageName="order-processing" />

    <div class="p-4 md:hidden mt-3">
      <slot name="tabs" />
    </div>

    <slot />

    <NuxtLayout name="center" class="print:hidden">
      <CommonLiveChatBlock />
    </NuxtLayout>
  </main>

  <!-- Footer -->
  <CheckoutFooter class="print:hidden" />
</template>

<script setup>
import { useGlobalStore } from "~/stores/global";

const globalStore = useGlobalStore();

const goHome = () => {
  // Clear session.
  // useClearCheckoutSession();

  const locale = switchBlogLocale();
  return reloadNuxtApp({ path: `/${locale}/` });
};

// Keep the order-processing flow out of search results via noindex. Do NOT block it
// with a robots.txt Disallow: `/*/order-processing` also matches the shared
// /_nuxt/order-processing.*.js chunks, which would break hydration site-wide.
useHead({
  meta: [{ name: "robots", content: "noindex, nofollow" }],
});

addAnalytics(globalStore.siteSettings.google_analytics_4_id);
addGTMAnalytics(globalStore.siteSettings.google_tag_manager_id);
</script>
